<template>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<div class="btn-group pull-right">
					<button v-on:click="$refs.mediacreate.open()" type="button" class="btn btn-success" title="Añadir media">
						<i aria-hidden="true" class="fa fa-plus"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="row">
			<template v-if="media">
				<template v-if="media.length">
					<template v-for="image in media">
						<div class="col-lg-2">
							<img :src="image.link" class="img-responsive">
							<div class="btn-group">
								<template v-if="image.pivot.tag != 'cover'">
									<button @click="markCover(image)" :disabled="loading" type="button" class="btn btn-success">Cover</button>
								</template>
								<button @click="destroy(image)" :disabled="loading" type="button" class="btn btn-danger">
									<i class="fa fa-trash" aria-hidden="true"></i>
								</button>
							</div>
						</div>
					</template>
				</template>
			</template>
		</div>
		<media-create
			@reload="reload"
			ref="mediacreate"
			:user="user"
			:isAuth="isAuth"
			:dropzone="dropzone">
		</media-create>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import MediaCreate from './../../../MediaManager/views/Create.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'media-create': MediaCreate,
		},
		data () {
			return {
				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_IMAGES,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/cms/articles/' + this.item.id,
					maxFileSizeInMB: 20,
					maxNumberOfFiles: 10,
				},

				media: null,

				loading: false,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/cms/articles/' + this.item.id + '/media')
					.then(response => {
						this.media = response.body
					})
			},
			markCover(media) {
				this.loading = true
				this.$http.get('admin/cms/articles/' + this.item.id + '/media/' + media.id + '/mark/cover')
					.then(response => {
						this.reload()
						this.loading = false
					})
			},
			destroy(media) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete(process.env.ROOT + '/api/' + that.$lang.getLang() + '/admin/media/' + media.id + '/destroy')
							.then(response => {
								that.reload()
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			}
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/cms/articles/views/Media.vue